import * as yup from "yup";
import { ICreateBatchBankTransfer } from "../../../../interfaces-and-types";
import { batchNotificationInterval, batchWebhookType } from "../../../../enums";
import { singleBankTransferSchema } from "./SingleBankTransferForm/singleBankTransferValidationSchema";
import { singleGatewayTransferSchema } from "./SingleGatewayTransferForm/singleGatewayTransferValidationSchema";

export const batchBankTransferSchema: yup.SchemaOf<ICreateBatchBankTransfer /* & IAddBankTransferEntryHelper */> =
  yup
    .object({
      batch_reference: yup.string().required("Batch reference is required"),
      title: yup.string().nullable().optional().max(150),
      pin: yup.string().required("PIN is required").max(8),
      description: yup.string().nullable().optional().max(300),
      source_currency: yup.string().required("Currency is required"),
      break_on_validation_failure: yup.boolean().nullable().optional(),
      scheduled_date: yup.string().nullable().optional(),

      transfers: yup.array().of(singleBankTransferSchema).required(),
      gateway_transfers: yup.array().of(singleGatewayTransferSchema).required(),

      batch_webhook_type: yup
        .mixed<batchWebhookType | null>()
        .oneOf(Object.values(batchWebhookType))
        .nullable()
        .optional(),
      batch_notification_interval: yup
        .mixed<batchNotificationInterval | null>()
        .oneOf(Object.values(batchNotificationInterval))
        .nullable()
        .optional(),
    })
    .required();
